<template>
  <b-modal
    id="modal-detalleTratamiento"
    size="lg"
    hide-footer
    header-class="p-0"
    body-class="pt-0"
  >
    <template #modal-header="{ close }">
      <div class="w-100 modal-header-internacion py-2 px-3 d-flex
        justify-content-between align-items-center">
        <h5 class="mb-0">Detalle Internacion N° {{ getNumeroItemChecked }}</h5>
        <button
          type="button"
          class="close"
          @click="close()"
        >&times;</button>
      </div>
    </template>

    <div class="row">
      <div class="col-sm-12 px-0">
        <b-table
          responsive
          class="table table-sm table-striped"
          :fields="fieldsTabla"
          :items="listaDetalle"
          :busy="isLoading"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
              <strong>Cargando...</strong>
            </div>
          </template>

          <template #head(accion)>
            <div class="text-center">
              <input
                type="checkbox"
                v-model="selectAll"
                @change="onToggleSelectAll"
                class="form-check-input position-static"
              >
            </div>
          </template>

          <template #cell(cantidad)="data">
            <div class="text-center">
              {{ data.item.cantidad }}
            </div>

          </template>

          <template #cell(servicio)="data">
            <span v-if="!data.item.hasSelect">{{ data.item.nombre }}</span>
            <div v-else class="d-flex align-items-center">
              <span class="mr-2 text-nowrap">{{ data.item.nombre }}</span>
              <multiselect
                v-model="data.item.servicioSelected"
                :options="listaServicios || []"
                placeholder=""
                label="nombre"
                track-by="id"
                select-label=""
                deselect-label="X"
              >
                <span slot="noResult">Sin Resultados</span>
                <span slot="noOptions">Lista Vacia</span>
                <template slot="singleLabel" slot-scope="props">
                  <small>{{ props.option.nombre }}</small>
                </template>
                <template slot="option" slot-scope="props">
                  <small>{{ props.option.nombre }}</small>
                </template>
              </multiselect>
            </div>
          </template>

          <template #cell(importe)="data">
            {{ data.item.importe | numeral('0,0.00') }}
          </template>

          <template #cell(accion)="items">
            <div class="text-center">
              <input
                :id="'checkDetalle' + items.index"
                v-model="items.item.checkInput"
                class="form-check-input position-static"
                type="checkbox"
              >
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 text-right">
        <button class="btn btn-outline-dark mr-2" @click="cancelarModal()">
          Cancelar
        </button>
        <button class="btn btn-success" @click="confirmarModal()">
          Guardar
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import { util } from '@/plugins/util';

export default {
  name: 'TheModalDetalleTratamiento',
  components: {
    Multiselect,
  },
  data() {
    return {
      fieldsTabla: [
        {
          key: 'cantidad',
          label: 'Cant.',
          thClass: 'th-custom-color-gray text-center',
          thStyle: { width: '8%' },
        },
        {
          key: 'servicio',
          label: 'Servicio',
          thClass: 'th-custom-color-gray',
        },
        {
          key: 'importe',
          label: 'Importe',
          thClass: 'th-custom-color-gray',
          thStyle: { width: '15%' },
          class: 'text-right',
        },
        {
          key: 'accion',
          label: '',
          thClass: 'th-custom-color-gray text-center',
          thStyle: { width: '5%' },
        },
      ],
    };
  },
  methods: {
    onToggleSelectAll() {
      this.toggleSelectAll(this.selectAll);
    },
    cancelarModal() {
      this.resetDetalle();
      this.$bvModal.hide('modal-detalleTratamiento');
    },
    confirmarModal() {
      const seleccionados = this.getItemsChecked;
      if (seleccionados.length === 0) {
        util.showNotify('Seleccione al menos un item', 'warn');
        return;
      }
      this.$bvModal.hide('modal-detalleTratamiento');
      this.$bvModal.show('modal-cierreTratamiento');
    },
    ...mapActions('modalDetalleTratamiento', ['resetDetalle']),
    ...mapMutations('modalDetalleTratamiento', ['toggleSelectAll']),
  },
  computed: {
    ...mapFields('modalDetalleTratamiento', [
      'listaDetalle',
      'isLoading',
      'selectAll',
    ]),
    ...mapGetters('modalDetalleTratamiento', ['getItemsChecked']),
    ...mapGetters('modalTratamientoEnCurso', ['getNumeroItemChecked']),
    ...mapFields('modalCierreTratamiento', ['listaServicios']),
  },
};
</script>

<style scoped>
.modal-header-internacion {
  background: rgb(186, 233, 255);
}
::v-deep .th-custom-color-gray {
  background: rgb(212, 212, 212);
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
